import { Component, ErrorHandler, Inject, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { FieldTree, form } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { Lasku } from '@lemon/core-firebase/model/lasku'

import { LaskuService } from '../../_angular/service/lasku/lasku.service'

import { LadataanService } from '../../_jaettu-angular/service/ladataan.service'

import { Subject } from 'rxjs'

export interface LaskuKommenttiDialogData {
  lasku: Lasku
}

interface KommenttiLomake {
  kommentti: string
}

@Component({
  templateUrl: './lasku-kommentti.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuKommenttiDialog implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>()

  namename = 'ogiujhnmfogiueufmbgjshfaklk' + Math.random()
  lomake: FieldTree<KommenttiLomake> = null

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: LaskuKommenttiDialogData,
    private dialogRef: MatDialogRef<LaskuKommenttiDialog>,
    private laskuService: LaskuService,
    private ladataanService: LadataanService,
    private errorHandler: ErrorHandler,
  ) {
    // Luo form
    this.lomake = form(signal<KommenttiLomake>({ kommentti: data.lasku.kommentti ?? '' }))
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  tallenna() {
    this.ladataanService.aloitaLataaminen()
    this.laskuService
      .tallennaKommentti(this.data.lasku, this.lomake.kommentti().value())
      .then(() => {
        this.ladataanService.lopetaLataaminen()
        this.dialogRef.close('onnistui')
      })
      .catch(err => {
        this.ladataanService.lopetaLataaminen()
        this.errorHandler.handleError(err)
      })
  }
}
